var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskSchedulerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,1.2h-3.2V0.5C11.3,0.2,11,0,10.8,0s-0.5,0.2-0.5,0.5v0.7H5.7V0.5C5.7,0.2,5.5,0,5.2,0 C5,0,4.7,0.2,4.7,0.5v0.7H1.6C0.7,1.2,0,1.9,0,2.7v11.7C0,15.3,0.7,16,1.6,16h12.8c0.9,0,1.6-0.7,1.6-1.6V2.7 C16,1.9,15.3,1.2,14.4,1.2z M1.6,2.1h3.2v0.7c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5V2.1h4.6v0.7c0,0.3,0.2,0.5,0.5,0.5 s0.5-0.2,0.5-0.5V2.1h3.2c0.3,0,0.6,0.3,0.6,0.6v1.5H1V2.7C1,2.4,1.2,2.1,1.6,2.1z M14.4,15H1.6C1.2,15,1,14.8,1,14.4V5.2H15v9.2 C15,14.8,14.8,15,14.4,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,9.1c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-1.5V6.9c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v1.2 H5.7V6.9c0-0.3-0.2-0.5-0.5-0.5C5,6.4,4.7,6.7,4.7,6.9v1.2H3.3C3,8.1,2.8,8.3,2.8,8.6c0,0.3,0.2,0.5,0.5,0.5h1.5v1.8H3.3 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h1.5v1.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-1.5h4.6v1.5 c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1.5h1.5c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-1.5V9.1H12.7z M10.3,10.9H5.7V9.1 h4.6V10.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSchedulerIcon);
export default __webpack_public_path__ + "static/media/task-scheduler-icon.7dfc39b8f5548cf825e6b4ac1b1481cf.svg";
export { ForwardRef as ReactComponent };